import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutComponent } from './about.component';
import { FragmentsModule } from 'src/app/fragments/fragments.module';



@NgModule({
  declarations: [AboutComponent],
  imports: [
    CommonModule,
    FragmentsModule,
  ]
})
export class AboutModule { }
